// extracted by mini-css-extract-plugin
export default {"container":"Title_container__8lrNm"};